/**
 * filter/BrowseMap
 *
 * Responsible for rendering browse results with dynamic map filter
 */
define('filter/BrowseMap',[
    'jquery',
    'ch_map_filter',
    'semantic',
    'ch_cookie',
], function ($, filterMap) {
    function initMapFilter(options) {
        options = Object.assign({
            searchResultsUpdated: () => {},
            popStateCb: () => {},
        }, options);
        /**
         * The thing that shows/hides the map
         * @type {*|jQuery|HTMLElement}
         */
        var $mapToggle = $('.js-show-map-toggle');

        /**
         * The filter form
         * @type {*|jQuery|HTMLElement}
         */
        var $simpleFilterForm = $('#filter-simple-form');

        /**
         * Map Bounding Box field
         * @type {*|jQuery|HTMLElement}
         */
        var $bboxField = $('input[name=bbox]', $simpleFilterForm);

        /**
         * Map Zoom field
         * @type {*|jQuery|HTMLElement}
         */
        var $zoomField = $('input[name=zoom]', $simpleFilterForm);

        /**
         * Is the map initialized via google's lib
         * @type {boolean}
         */
        var isMapInitialized = false;

        /**
         * Is the map being shown to the user
         * False when hidden
         *
         * @type {boolean}
         */
        var isMapDisplayed = !!$mapToggle.data('is-map-displayed');

        /**
         * Map container element
         * @type {*|jQuery|HTMLElement}
         */
        var $mapContext = $('#filter-map-context');

        /**
         * Element where map will be rendered within
         * @type {*|jQuery|HTMLElement}
         */
        var $mapElement = $('#filter-map', $mapContext);

        /**
         * default center coordinate for map
         */
        var center = {
            lat: CH && CH.Hub && CH.Hub.latitude,
            lng: CH && CH.Hub && CH.Hub.longitude,
        };

        /**
         * default zoom level for map
         */
        var zoom = 12;

        // determine default map center (and zoom) based on previously submitted bounding-box search param

        /**
         * Bounding Box value
         * @type {integer}
         */
        var bbox = $bboxField.val().split(',');
        if (bbox && bbox.length === 3) {
            center.lat = parseFloat(bbox[0]);
            center.lng = parseFloat(bbox[1]);
            zoom = parseFloat($zoomField.val());
        }

        var userMapDisplayPreference = parseInt(CH.getCookie('ch_map'));

        $mapToggle.checkbox();

        // if user has clicked to display the map
        // then set all the map values as though it is "displayed"
        if (userMapDisplayPreference) {
            $mapToggle.data('is-map-displayed', 1);
            $mapToggle.checkbox('check');
            isMapDisplayed = true;
        }

        /**
         * Show/Hide the map element
         * Save the selection made by the user for persistence
         *
         * @param isShowMap
         */
        function toggleMap(isShowMap) {
            // Theses elements need to be reselected after search results are returned
            var $filterResultsColumn = $('.js-filter-results-column', '#filter-results');
            var $courseImageCol = $('.js-course-image', $filterResultsColumn);
            var $courseBodyCol = $('.js-course-body', $filterResultsColumn);
            var $courseControlsCol = $('.js-course-controls', $filterResultsColumn);
            var $giftCardAd = $('.js-giftcard-body', $filterResultsColumn);
            var $courseSchedules = $('.js-course-schedules-column', $filterResultsColumn);
            var $courseSchedulesOffset = $('.js-course-schedules-offset', $filterResultsColumn);

            // we remove ALL SemanticUI grid classes first, to maintain exact class order as SemanticUI wants it
            // ex: addClass("five wide") should add exactly "five" "space" "wide" in order into the class attribute value
            // why: if class="five wide", removeClass("six wide") removes "wide" but not "six"
            // then the subsequent addClass("five wide") will only add "wide" at the end of the class list, which does not work with semantic
            var gridClasses = 'one two three four five six seven eight nine ten eleven twelve thirteen fourteen fifteen sixteen wide';

            isMapDisplayed = !!$mapToggle.data('is-map-displayed');
            isShowMap = typeof isShowMap === 'undefined' ? !isMapDisplayed : isShowMap;

            // semantic-ui wants "# wide" classes in order
            // and toggle() doesn't play super nice with that
            if (isShowMap) {
                $mapContext.removeClass(gridClasses).addClass('eight wide').show();
                $mapToggle.data('is-map-displayed', 1);
                CH.setCookie('ch_map', 1);

                $filterResultsColumn
                    .removeClass(gridClasses)
                    .addClass('eight wide');

                $courseImageCol
                    .removeClass(gridClasses)
                    .addClass('six wide');

                $courseBodyCol
                    .removeClass(gridClasses)
                    .addClass('ten wide');

                $courseControlsCol
                    .removeClass(gridClasses)
                    .addClass('six wide');

                $giftCardAd
                    .removeClass(gridClasses)
                    .addClass('sixteen wide');

                $courseSchedules
                    .removeClass(gridClasses)
                    .addClass('sixteen wide');

                $courseSchedulesOffset
                    .hide();

                ga('send', 'event', 'Filter Map', 'show', null, {
                    nonInteraction: false,
                });
            } else {
                $mapContext.removeClass(gridClasses).hide();
                CH.setCookie('ch_map', 0);
                $mapToggle.data('is-map-displayed', 0);

                $filterResultsColumn
                    .removeClass(gridClasses)
                    .addClass('sixteen wide');

                $courseImageCol
                    .removeClass(gridClasses)
                    .addClass('five wide');

                $courseBodyCol
                    .removeClass(gridClasses)
                    .addClass('eight wide');

                $courseControlsCol
                    .removeClass(gridClasses)
                    .addClass('three wide');

                $giftCardAd
                    .removeClass(gridClasses)
                    .addClass('nine wide');

                $courseSchedules
                    .removeClass(gridClasses)
                    .addClass('eleven wide');

                $courseSchedulesOffset
                    .show();

                ga('send', 'event', 'Filter Map', 'hide', null, {
                    nonInteraction: false,
                });
            }
        }

        /**
         * Handler for when a user clicks an "overlay" in the map
         * @param recordId
         */
        function overlayClickHandler(recordId) {
            // when user clicks a map pin or overlay
            // then update the filter and refresh the results
            $simpleFilterForm
                .find('input[name=location]')
                .val(recordId)
                .trigger('change');
        }

        /**
         * Initialize (once) the map with google maps lib
         * When a map element is hidden (display:none) google maps will not render in the container
         */
        function initMap() {
            if (!isMapInitialized) {
                filterMap.init(
                    $mapElement[0],
                    {
                        defaultZoomLevel: zoom,
                        defaultCenter: center,
                        mapChangeCallback: function (mapDetails) {
                            // this function is triggered after user changes the map display in any way
                            // set the map view details in our filter form and submit it
                            $zoomField.val(mapDetails.zoom);
                            $bboxField
                                .val(mapDetails.lat + ',' + mapDetails.lng + ',' + mapDetails.radius)
                                .trigger('change', { recordHistory: false });
                        },
                        markerClickCallback: overlayClickHandler,
                        overlayClickCallback: overlayClickHandler,
                    }
                );

                // finally, tell the map about our current browse results, which were loaded via php (not ajax)
                if (CH && CH.browseResults) {
                    searchResultsUpdated(CH.browseResults);
                    filterMap.fit();
                }

                // make the map sticky
                $('.ui.sticky', $mapContext).sticky({
                    offset: $('#filter-simple-container').height() + 15, // px offset from the top of the page when sticky
                    observeChanges: true, // adjust to page size changes
                    context: '#filter-results', // "sticks" to this element as it scrolls
                });

                isMapInitialized = true;
            }
        }

        // when the map toggle button is clicked
        $mapToggle.on('change', function () {
            // shift all the columns
            toggleMap();
            // make sure map is initialized
            initMap();
        });

        // initialize if map is supposed to be displayed by default
        if (isMapDisplayed) {
            // adjust columns, unhide map
            toggleMap(true);
            // then initialize after everything else async is complete
            // so that the map renders once the page is done loading
            setTimeout(function () {
                initMap();
            }, 0);
        }

        // @todo - belongs here or in SimpleFilter component?
        // we will call this function from the SimpleFilter component, when a user clicks the back button
        // when user goes "back" we re-set the bbox & zoom fields in the simple filter
        // @note - set here intentionally to update the function in an outer scope
        popStateCb = function () {
            var zoom = $zoomField.val();
            var bbox = $bboxField.val().split(',');

            if (isMapInitialized) {
                filterMap.setCenterAndZoom(
                    bbox && bbox[0] ? bbox[0] : null,
                    bbox && bbox[1] ? bbox[1] : null,
                    zoom,
                    false
                );
            }
        };

        // we will call this function after the filter completes loading new search results
        // @note - set here intentionally to update the function in an outer scope
        searchResultsUpdated = function (results) {
            // tell our map about the new results
            filterMap.refreshData(results);

            $browseResultRows.on('mouseover', function (e) {
                filterMap.showOverlayForRecord($(this).data('location-id'));
            });
            $browseResultRows.on('mouseout', function (e) {
                filterMap.hideOverlayForRecord($(this).data('location-id'));
            });
        };
    }

    return {
        init: initMapFilter,
    };
});

